<template>
    <div class="component-container">
        <InfoContainer
            id="basicForm"
            :infoTitle="contentConfig['infoTitle']"
            :contentConfig="contentConfig['infoContent']"
        >
            <template #basicInfo>
                <CommonDetail
                    v-if="isDetail"
                    :configArray="basicInfoFormConfig"
                    :initValue="formOneData"                    
                />                
                <avue-form
                    ref="basicInfo"
                    v-else
                    v-model="formOneData"
                    :option="basicInfoConfig"
                >
                    <template #name>
                        <!-- 存在绑定ID时不可更改项目 -->
                        <!-- :disabled="$route.params.id && $route.params.id != ''?true:false" -->
                        <CommonSelect
                            bindLabel="name"
                            bindKey="id"
                            bindValue="name"
                            dataUrl="bl/blreportstandard/page"
                            methods="get"
                            dataMethod="params"
                            searchKey="name"
                            :initParam="initParam"
                            :bindId="formOneData.selectId?formOneData.selectId:''"
                            @handleChange="setSurveyProjectInfo"
                        />
                    </template>
                </avue-form>
            </template>

            <template #contractInfo>
                <CommonDetail
                    v-if="isDetail"
                    :configArray="contractInfoFormConfig"
                    :initValue="formTwoData"                    
                />                
                <avue-form
                    ref="contractInfo"
                    v-else
                    v-model="formTwoData"
                    :option="contractInfoConfig"
                >
                    <template #contractName>
                        <!-- 存在绑定ID时不可更改项目 -->
                        <!-- :disabled="$route.params.id && $route.params.id != ''?true:false" -->
                        <CommonSelect
                            bindLabel="contractName"
                            bindKey="id"
                            bindValue="contractName"
                            dataUrl="bl/blcontractmanage/searchList"
                            methods="get"
                            dataMethod="params"
                            searchKey="contractName"
                            :initParam="contractParam"
                            :bindId="formTwoData.selectId?formTwoData.selectId:''"
                            @handleChange="setContractInfo"
                        />
                    </template>
                    <template #quotaName>
                        <el-select value-key="id" v-model="planData" clearable filterable placeholder="请选择报价方案" @change="setPlanData">
                            <el-option
                                v-for="item in rentList"
                                :key="item.id"
                                :label="item.name"
                                :value="item"
                            >
                            </el-option>
                        </el-select>
                    </template>
                </avue-form>
            </template>

            <template #receivablesInfo>
                <!-- 其它应收款项表格 -->
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                >
                    <el-table-column
                        type="index"
                        align="center"
                        label= "序号"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="outlayTypeStr"
                        label="款项类型"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="moneyRate"
                        label="比例/金额"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="isBuckle"
                        label="是否内扣"
                    >
                    </el-table-column>
                    <el-table-column
                        align="center"
                        property="planDate"
                        label="计划收取时间"
                        width="250"
                    >
                        <template slot-scope="scope">
                            <div class="plan-date" v-if="isDetail">{{scope.row.planDate}}</div>
                            <!-- <div class="plan-date" v-if="isDetail">{{row.planDate}}</div> -->
                            <el-date-picker
                                v-else
                                size="small"
                                v-model="scope.row.planDate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        align="center"
                        property="others"
                        label="其它"
                    >
                    </el-table-column> -->
                </el-table>
            </template>

            <template #loanInfo>
                <CommonDetail
                    v-if="isDetail"
                    :configArray="extraFormConfig"
                    :initValue="formTwoData"                    
                />                
                <avue-form
                    ref="inventInfo"
                    v-else
                    v-model="formTwoData"
                    :option="loanInfoConfig"
                >
                    <template #investBatchStr>
                        <div class="slot-content">{{formTwoData.investBatchStr?formTwoData.investBatchStr: '无'}}</div>
                    </template>

                    <template #investAmount>
                        <div class="slot-content">{{formTwoData.contractFactoringCredit?`${formTwoData.contractFactoringCredit}元`:'无'}}</div>
                    </template>

                    <template #innerReduce>
                        <div class="slot-content green-word">{{formTwoData.innerReduceStr?`${formTwoData.innerReduceStr}`:'无'}}</div>
                    </template>

                    <template #netInvestAmount>
                        <div class="slot-content green-word">{{formTwoData.netInvestAmount?`${formTwoData.netInvestAmountStr}`:'无'}}</div>
                    </template>

                    <template #bankId>
                        <CommonSelect
                            bindLabel="bankOpenName"
                            bindKey="id"
                            bindValue="bankOpenName"
                            dataUrl="bl/custbankbl/page"
                            methods="get"
                            dataMethod="params"
                            searchKey="bankOpenName"
                            :initParam="bankParam"
                            :bindId="formTwoData.selectBankId?formTwoData.selectBankId:''"
                            @handleChange="setBankInfo"
                        />
                    </template>
                    
                </avue-form>
            </template>
        </InfoContainer>
    </div>
</template>
<script>
import {addFormOne, addFormTwo, addFormThree, basicInfoFormConfig, contractInfoConfig, extraFormConfig} from "../ILManageConfig"
import { getUsedAmount, queryInvestLoanDetail, queryBankInfo } from "@/api/factoring/factoring";
import Accessory from "@/components/accessoriesother/accessory"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommonDetail from "@/components/commonDetail/commonDetail"
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util"
import { floatAdd,floatMul } from "@/util/util";

export default {
    name: "CommonForm",
    mixins: [workFlow, util],
    data() {
        return {
            // initParam: {auditStatus: 2},
            // bankParam: { custId },
            virtualId: '',
            initParam: {},
            contractParam: {isInvest: 1},
            bankParam: {},
            planParam: {},
            titleName: '投放申请单',
            formOneData: {},
            formTwoData: {
                remarks:''
            },
            tableData: [],
            rentList: [],
            planData: {},
            basicInfoConfig: addFormOne(),
            contractInfoConfig: addFormTwo(),
            loanInfoConfig: addFormThree(),
            basicInfoFormConfig: basicInfoFormConfig(),
            contractInfoFormConfig: contractInfoConfig(),
            extraFormConfig: extraFormConfig(),
            firstType:false
        }
    },
    props: {
        id: {
            type:String,
            default: ''
        },
        isDetail: {
            type: Boolean,
            default: false
        },
        // 传入的详细数据
        bindData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    computed: {
        ...mapGetters(['userInfo']),
        contentConfig: {
            get() {
                return {
                    infoTitle: this.titleName,
                    infoContent: [{
                        title: '基础信息',
                        prop: 'basicInfo'
                    },{
                        title: '合同信息',
                        prop: 'contractInfo'
                    },{
                        title: '其它应收款项',
                        tips: '(请结合实际情况确定相关确款项的收取日期，审批通过之后将自动生成应收)',
                        prop: 'receivablesInfo',
                        display: 'true'
                    },{
                        title: '本批次放款信息',
                        prop: 'loanInfo'
                    }]
                }
            },
            set(val) {

            }
        }
    },
    components: {
        Accessory,
        CommonSelect,
        CommonDetail,
        InfoContainer
    },
    watch: {
        'tableData':{
            handler(newData, oldData) {
                this.$forceUpdate()
                this.$nextTick()
            },
            deep:true
        },
        bindData: {
            handler(newData, oldData) {
                if(newData.id && newData.id != '') {
                    this.dealDetailData(newData)
                }
            },
            immediate: true
        },
        formTwoData: {
            handler(val) {
                if (this.$refs.basicInfo) {
                      this.$refs.basicInfo.clearValidate();
                }
                if (this.$refs.contractInfo) {
                      this.$refs.contractInfo.clearValidate();
                }
            },
            deep: true,
        },

    },
    async mounted() {
        // 详细页不执行查询详情操作
        if(this.$route.params.id && !this.isDetail) {
            // 查询投放管理详细信息
            // this.queryDetailData()
            this.firstType=true;
            this.titleName = '编辑投放申请'
            this.$forceUpdate()
        }
    },
    methods: {
        async queryDetailData() {
            let id = this.$route.params.id
            let res = await queryInvestLoanDetail({ id })
            if(res.data.code == 200) {
                this.dealDetailData(res.data.data)
            }            
        },

        async dealDetailData(initData) {
            let self = this
            let dataOne = {}
            let dataTwo = {}
            let awaitOne = this.queryDict(initData.blReportStandard.projectType, '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type')
            let awaitTwo = getUsedAmount({id: initData.blReportStandard.projectInfoId})
            let awaitThree = this.queryDict(initData.blContractRental.repaymentFrequency, '/api/blade-system/dict-biz/dictionary?code=repayment_frequency')
            let awaitFour = this.queryBankId(initData.bankId)
            
            dataOne.projectName = initData.blReportStandard.name
            dataOne.custId = initData.custId
            dataOne.selectId = initData.reportId
            dataOne.managerUserName = initData.managerUserName
            dataOne.assistUserName = initData.assistUserName
            dataOne.projectTypeStr = initData.blReportStandard.projectTypeStr
            //合同信息
            dataTwo.selectId = initData.contractId
            dataTwo.rentId = initData.blContractRental.id
            dataTwo.selectBankId = initData.bankId
            dataTwo.investCredit = initData.thisInvestMoney
            dataTwo.contractName = initData.contractManage.contractName
            dataTwo.quotaName = initData.blContractRental.name
            dataTwo.sellerCustName = initData.blReportStandard.sellerCustName
            dataTwo.contractFactoringCredit = this.getMoney(Number(initData.blContractRental.quotationPrice))
            dataTwo.downPayment = initData.blContractRental.downPayment.split(',')[1]
            dataTwo.downPaymentStr = this.getMoney(Number(initData.blContractRental.downPayment.split(',')[1]))
            dataTwo.downPaymentRate = initData.blContractRental.downPayment.split(',')[0]
            dataTwo.leaseTerm = initData.blContractRental.leaseTerm
            dataTwo.graceFlagStr = initData.blContractRental.graceFlag == -1?'无':initData.blContractRental.graceFlag == 0?'否':'是'
            // dataTwo.gracePeriodDay = initData.blContractRental.gracePeriodDay
            // dataTwo.graceInterestRate = initData.blContractRental.graceInterestRate
            dataTwo.gracePeriodDayRate = initData.blContractRental.gracePeriodDay && initData.blContractRental.gracePeriodDay !== -1?`${Number(initData.blContractRental.gracePeriodDay)}天,${floatMul(Number(initData.blContractRental.graceInterestRate),100)}%`:'无'
            
            dataTwo.xirrStr = (Number(initData.blContractRental.xirr)*100).toFixed(4)
            dataTwo.xirr = (Number(initData.blContractRental.xirr)*100).toFixed(4)
            // 是否宽限期
            dataTwo.graceFlag = initData.blContractRental.graceFlag && initData.blContractRental.graceFlag != -1?`${initData.blContractRental.graceFlag}`: 0
            // 宽限期及使用费率
            dataTwo.graceInterestDayRate = initData.blContractRental.gracePeriodDay!='' && initData.blContractRental.gracePeriodDay !== -1?`${initData.blContractRental.gracePeriodDay}天，${(Number(initData.blContractRental.graceInterestRate)*100).toFixed(2)}%`:'-'
            // 逾期使用费率
            dataTwo.overdueInterestRateStr = initData.blContractRental.overdueInterestRate && initData.blContractRental.overdueInterestRate != -1?`${(Number(initData.blContractRental.overdueInterestRate)*100).toFixed(2)}%`:''

            dataTwo.annualInterestRate = floatMul(Number(initData.blContractRental.annualInterestRate),100)

            let promiseList = [awaitTwo,awaitThree,awaitFour]
            dataTwo.innerReduce = 0
            initData.otherOutlayVOS.map(item => {
                item = self.dealTableData(item)
                // 需内扣总金额
                if(item.outlayWay == 1){
                    dataTwo.innerReduce =floatAdd(dataTwo.innerReduce,Number(item.outlayAmount))                         
                }
            
            })
            self.tableData = initData.otherOutlayVOS

            // 批次放款信息
            dataTwo.investBatchStr = `第${initData.investBatch}批`

            dataTwo.rentDate = initData.rentDate
            // 本批次投放金额
            dataTwo.investAmount = this.getMoney(Number(initData.blContractRental.quotationPrice))
            // dataTwo.innerReduce = this.getMoney(Number(initData.blContractRental.quotationPrice) - Number(initData.cleanMoney))
            dataTwo.innerReduceStr = `${this.getMoney(dataTwo.innerReduce)}`
            dataTwo.netInvestAmount = Number(initData.blContractRental.quotationPrice - dataTwo.innerReduce)
            dataTwo.netInvestAmountStr = `${this.getMoney(Number(dataTwo.netInvestAmount))}`            
            // 需内扣金额
            dataTwo.isInvestCondition = initData.isInvestCondition
            dataTwo.isInvestConditionStr = initData.isInvestCondition == 0?'否':'是'
            dataTwo.otherCondition = initData.otherCondition||initData.remarks
            
            Promise.all(promiseList).then(res => {
                // 基础信息
                let amountData = res[0]
                dataTwo.repaymentFrequencyStr = res[1]
                // 银行信息

                dataOne.factoringCredit = Number(self.bindData.blReportStandard.factoringCredit)
                dataOne.factoringCreditStr = self.getMoney(Number(self.bindData.blReportStandard.factoringCredit))
                // 查询已用额度
                dataOne.usedFinancingQuota = `${(self.getMoney(Number(amountData.data.data)))}`
                // 可用额度
                dataOne.usableFinancingQuota = `${self.getMoney(Number(dataOne.factoringCredit)-Number(amountData.data.data))}`

                dataTwo.bankInfo = `${res[2].records[0].bankAccountName} ${res[2].records[0].bankOpenName} ${res[2].records[0].bankNo}`
                dataTwo.bankId = res[2].records[0].id
                self.formOneData = {...dataOne}
                self.formTwoData = {...dataTwo}
            })
        },

        emitFormInfo() {
            let submitForm = {
                ...this.formOneData,
                ...this.formTwoData
            }
            this.$emit('submitForm', submitForm)
        },

        // 选择尽调项目后回显项目信息
        async setSurveyProjectInfo(data) {
            if(JSON.stringify(data) != '{}'){


                this.$emit("setBasicInfoData",data)
                this.formOneData.name = data.name
                // 尽调ID
                this.formOneData.reportId = data.id
                // 业务类型
                this.formOneData.projectTypeStr = data.projectTypeStr
                // 融资额度
                this.formOneData.factoringCredit = data.factoringCredit
                this.formOneData.factoringCreditStr = data.factoringCredit?`${this.getMoney(Number(data.factoringCredit))}`:''

                // 客户ID
                this.formOneData.custId = data.sellerCustId

                // 查询已用额度
                let amountData = await getUsedAmount({id: data.projectInfoId})
                this.formOneData.usedFinancingQuota = `${(this.getMoney(Number(amountData.data.data)))}`
                // 可用额度
                this.formOneData.usableFinancingQuota = `${this.getMoney(Number(data.factoringCredit)-Number(amountData.data.data))}`
                // 业务主办
                this.formOneData.managerUserName = data.managerUserName
                this.formOneData.assistUserName = data.assistUserName

                // 设置保理合同选择参数
                this.contractParam = {reportId: data.id, isInvest: 1}
            } else {
                // 清空数据
                this.formOneData = {}
                this.formTwoData = {}
            }

        },

        // 选择合同后回显合同方案数据
        setContractInfo(data) {
            if(JSON.stringify(data) != '{}') {
                // 合同ID
                this.formTwoData.contractId = data.id

                this.formTwoData.contractName = data.contractName
                // 合同金额
                // this.formTwoData.contractFactoringCredit = data.factoringCredit?`${this.getMoney(Number(data.factoringCredit))}`:''
                // 债权人
                this.formTwoData.sellerCustName = data.sellerCustName
                // 内部收益率
                this.formTwoData.xirr=""
                // this.formTwoData.xirr = `${(Number(data.xirr)*100).toFixed(4)}`
                // 报价方案数据
                this.rentList = data.blContractRental

                // 设置收款银行信息接口参数
                this.bankParam = { custId: data.sellerCustId }
                // 若url中带有ID， 设置详细数据
                let self = this
                if(this.$route.params.id && this.$route.params.id != '') {
                    let setData = data.blContractRental.filter((item) => {
                        return item.id == self.formTwoData.rentId
                    })
                    this.planData = setData[0]
                    // this.setPlanData(setData[0])
                }
            } else{
                this.formTwoData = {}
                this.tableData = []
            }
            if(this.firstType){
               this.firstType=false 
               this.dealDetailData(this.bindData)
            }

        },

        // 选择方案后回显方案数据
        async setPlanData(data) {
            if(JSON.stringify(data) != '{}') {
                this.formTwoData.rentId = data.id
                this.formTwoData.quotaName = data.name
                // 合同金额
                this.formTwoData.quotationPrice = data.quotationPrice
                this.formTwoData.contractFactoringCredit = data.quotationPrice?`${this.getMoney(Number(data.quotationPrice))}`:''
                // 首付款
                this.formTwoData.downPayment = data.downPayment.split(',')[1]
                // 首付款收取费率
                this.formTwoData.downPaymentRate = `${(Number(data.downPayment.split(',')[0])*100).toFixed(2)}`
                // 还款期限
                this.formTwoData.leaseTerm = data.leaseTerm
                // 是否宽限期
                this.formTwoData.graceFlag = data.graceFlag && data.graceFlag != -1?`${data.graceFlag}`: 0
                // 宽限期及使用费率
                this.formTwoData.graceInterestDayRate = data.gracePeriodDay!='' && data.gracePeriodDay !== -1?`${data.gracePeriodDay}天，${(Number(data.graceInterestRate)*100).toFixed(2)}%`:'-'
                // 逾期使用费率
                this.formTwoData.overdueInterestRateStr = data.overdueInterestRate && data.overdueInterestRate != -1?`${(Number(data.overdueInterestRate)*100).toFixed(2)}%`:''
                // 年租息率
                this.formTwoData.annualInterestRateStr = data.annualInterestRate && data.annualInterestRate !== -1?`${(Number(data.annualInterestRate)*100)}%`:''
                // 其它条件
                // 租金还款频次
                this.formTwoData.repaymentFrequency = data.repaymentFrequency
                this.formTwoData.repaymentFrequencyStr = await this.queryDict(data.repaymentFrequency, '/api/blade-system/dict-biz/dictionary?code=repayment_frequency')
                // 内部收益率
                this.formTwoData.xirr = `${(Number(data.xirr)*100).toFixed(4)}`
                this.formTwoData.investBatch = data.investBatch
                this.formTwoData.investBatchStr = `第${data.investBatch}批`

                // 其它应收款项
                let self = this
                let promiseList = []
                self.formTwoData.innerReduce = 0
                if(data.outlayVOS.length > 0) {
                    data.outlayVOS.map((item)=> {
                        promiseList.push(self.dealTableData(item))
                        // 需内扣总金额
                        if(item.outlayWay == 1){
                            self.formTwoData.innerReduce =floatAdd(self.formTwoData.innerReduce,Number(item.outlayAmount)  )                       
                        }
                    })
                    self.tableData = data.outlayVOS
                    // Promise.all(promiseList).then(res => {
                    //     self.tableData = res
                    // })
                    this.contentConfig.infoContent[2].display = 'true'

                    this.formTwoData.innerReduceStr = `${this.getMoney(this.formTwoData.innerReduce.toFixed(2))}元`
                    this.formTwoData.netInvestAmount = Number(this.formTwoData.quotationPrice) - this.formTwoData.innerReduce
                    this.formTwoData.netInvestAmountStr = `${this.getMoney(Number(this.formTwoData.quotationPrice) - this.formTwoData.innerReduce)}元`
                } else {
                    this.tableData = []
                    this.formTwoData.innerReduce = 0
                    this.formTwoData.innerReduceStr = `${this.getMoney(this.formTwoData.innerReduce.toFixed(2))}元`
                    this.formTwoData.netInvestAmount = Number(this.formTwoData.quotationPrice)
                    this.formTwoData.netInvestAmountStr = `${this.getMoney(Number(this.formTwoData.quotationPrice) - this.formTwoData.innerReduce)}元`
                }
            }
        },

        setBankInfo(data) {
            this.formTwoData.bankId = data.id
        },

        queryBankId(id) {
            return new Promise(async(resolve, reject) => {
                let res = await queryBankInfo({id})
                if(res.data.code == 200) resolve(res.data.data)
            })
        },

        dealTableData(data) {
            data.moneyRate = `${floatMul(Number(data.outlayRate),100)}% / ${this.getMoney(Number(data.outlayAmount))}元`
            data.isBuckle = data.outlayWay == 1?'是': '否'
            data.investId = this.virtualId
            data.outlayId = data.otherOutlayId
            return data
        },

        validForm() {
            let self = this
            return new Promise((resolve, reject) => {
                self.$refs.basicInfo.validate((validOne, doneOne) => {
                    if(validOne) {
                        doneOne()
                        self.$refs.contractInfo.validate((validTwo, doneTwo) => {
                            doneTwo()
                            if(validTwo) {
                                self.$refs.inventInfo.validate((validThree, doneThree) => {
                                    if(validThree) {
                                        doneThree()
                                        // 判断其它应收款项是否选择数据
                                        if(self.tableData.length > 0) {
                                            let fillAll = true
                                            self.tableData.map(item => {
                                                if(!item.planDate || item.planDate == '') {
                                                    fillAll = false
                                                }
                                            })
                                            if(fillAll) {
                                                resolve(true)
                                            }else {
                                                self.$message({
                                                    type: 'warning',
                                                    message: '请补全应收款项计划收取时间'
                                                })
                                            }
                                        }else {
                                            resolve(true)
                                        }
                                        
                                    }else {
                                        self.$message({
                                            type: 'warning',
                                            message: '请补全放款批次信息'
                                        })
                                    }
                                })
                            }else {
                                self.$message({
                                    type: 'warning',
                                    message: '请补全合同信息'
                                })
                            }
                        })
                    } else {
                        self.$message({
                            type: 'warning',
                            message: '选择项目'
                        })
                    }
                })
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.component-container{
    /deep/.info-container-temp .box-card .detail-one{
        padding-bottom: 0 !important;
    }
    .green-word{
        font-weight: 400;
        font-style: normal;
        color: #33CCB0;
    }
}
</style>